import React from 'react'
import { useNavigate } from 'react-router-dom';
export default function Template() {
    const navigate = useNavigate();
  return (
    <section className="blog--section">
      <div>
        <h2>Gallery</h2>
        <p className="text-lg">
          Welcome to my Gallery! Here you'll find all my latest blogs, and other updates.
          Coming soon, stay tuned!
        </p>
        <button className={`bg-black hover:bg-slate-500 text-white font-bold py-2 px-4 rounded`} onClick={() => navigate('/')}>Main Menu</button>
        {/* Add your blog content here */}
      </div>
    </section>
  );
}
